import { useState } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
import { AuthShell } from "@/components/AuthShell";
import { Field, PrimaryButton, FormAlert, inputCls } from "@/components/FormBits";
import { api, formatApiError, maskPhone, phoneDigits } from "@/lib/api";

export default function ForgotPassword() {
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (ev) => {
    ev.preventDefault();
    setError("");
    if (phoneDigits(phone).length < 10) {
      setError("Digite o celular cadastrado, com DDD.");
      return;
    }
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { phone: phoneDigits(phone), message });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell testId="forgot-page" backTo="/entrar" title="Esqueci minha senha" subtitle="Envie um pedido e nossa equipe vai redefinir sua senha e avisar você pelo WhatsApp.">
      {sent ? (
        <div data-testid="forgot-success" className="space-y-6">
          <div className="flex gap-3 rounded-2xl border-2 border-emerald-200 bg-emerald-50 p-5 text-lg text-emerald-900">
            <CheckCircle2 className="h-7 w-7 shrink-0 text-emerald-700" />
            Pedido enviado! Em breve entraremos em contato pelo WhatsApp com sua nova senha.
          </div>
          <Link to="/entrar" data-testid="forgot-back-login-link" className="flex min-h-[60px] items-center justify-center rounded-2xl border-2 border-emerald-700 font-heading text-xl font-bold text-emerald-800 hover:bg-emerald-50">
            Voltar para entrar
          </Link>
        </div>
      ) : (
        <form onSubmit={submit} noValidate className="space-y-6" data-testid="forgot-form">
          <Field id="forgot-phone" label="Celular cadastrado">
            <input id="forgot-phone" data-testid="forgot-phone-input" className={inputCls} value={phone} onChange={(e) => setPhone(maskPhone(e.target.value))} inputMode="numeric" placeholder="(11) 98765-4321" />
          </Field>
          <Field id="forgot-message" label="Recado" hint="(opcional)">
            <textarea id="forgot-message" data-testid="forgot-message-input" rows={3} maxLength={500} className={`${inputCls} py-3`} value={message} onChange={(e) => setMessage(e.target.value)} placeholder="Ex: melhor horário para falar comigo" />
          </Field>
          <FormAlert testId="forgot-error">{error}</FormAlert>
          <PrimaryButton type="submit" loading={loading} data-testid="forgot-submit-button">Pedir nova senha</PrimaryButton>
        </form>
      )}
    </AuthShell>
  );
}
